import BrowserPreview from './BrowserPreview';

export default BrowserPreview;
